import TemplateView from '../../../TemplateView'
import messageResource from '../../../messageResource'
import Button from "../../../components/Button";
export default class CreateProjectLightboxFooter extends TemplateView {

    constructor() {
        super(null)
    }

    templateHtml() {
        return '<div class="createProjectLightBoxFooter">' +
               '    <div class="errorMessageBox">' +
               '        <div class="errorIcon"/>' + //TODO styles
               '        <span class="errormsg"><%-errorMessage%></span>' +
               '    </div>' +
               '    <div class="buttonsBox">' +
               '        <span class="changesMsg"><%-projectNotSaved%></span>' +
               '        <span class="savingMsg"><%-projectSaving%></span>' +
               '        <div class="commitButtonPlaceHolder"/> ' +
               '        <div class="greyButton cancelBtn"><%-cancelBtn%></div>' +
               '    </div>' +
               '</div>'
    }


    afterRender() {
        let title = messageResource.getMessage("project.add.create_btn_title")
        if(title.length > 17) {
            title = messageResource.getMessage("project.add.default_create_btn_title")
        }
        this.commitButton = new Button({
            label: title,
            withPlusIcon: true,
        }).init(this.find('.commitButtonPlaceHolder'))
    }

    messageKeys() {
        return {
            errorMessage: 'project.common.errormsg',
            projectNotSaved: 'project.common.not_saved',
            projectSaving: 'project.common.saving',
            cancelBtn: 'common.cancel'
        }
    }

    getCommitBtnEl() {
        return this.commitButton.getEl();
    }

    getCancelBtnEl() {
        return this.find('.cancelBtn')
    }
}



// WEBPACK FOOTER //
// ./web/js/taskManagement/createLightbox/project/CreateProjectLightBoxFooter.js